export default [
    { text: 'Alias', value: 'alias_name' },
    { text: 'Nombre', value: 'name' },
    { text: 'UPC', value: 'upc' },
    { text: 'Precio Base', value: 'sale_price' },
    { text: '% dcto', value: 'discount', sortable: false },
    { text: 'Precio Oferta', value: 'offer_price', sortable: false },
    { text: '', value: '', sortable: false },
]
